import { css } from '@emotion/css';

export const emptyStateStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 24px',
  textAlign: 'center',
  color: 'var(--streamlain-v2-text-secondary)',
});

export const emptyStateTitleStyle = css({
  fontSize: '14px',
  fontWeight: 600,
  color: 'var(--streamlain-v2-text-primary)',
});

export const emptyStateHintStyle = css({
  fontSize: '13px',
  maxWidth: '320px',
});

export const emptyStateCtaStyle = css({
  appearance: 'none',
  border: '1px solid var(--streamlain-v2-layer-insideBorder-border)',
  padding: '6px 14px',
  borderRadius: '4px',
  fontSize: '13px',
  cursor: 'pointer',
  background: 'var(--streamlain-v2-button-primary)',
  color: 'var(--streamlain-v2-button-pureWhiteText)',

  '&:hover': {
    filter: 'brightness(1.05)',
  },
});

export const validationIconStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  background: 'var(--streamlain-v2-status-error)',
  color: 'var(--streamlain-v2-layer-white)',
  fontSize: '11px',
  fontWeight: 700,
  cursor: 'help',
});
